import { useTranslation } from "react-i18next";
import { useJourneyDynamicDetails } from "../../../../context";
import { useSSRContext } from "../../context/SSRContext";
import { getRowTotal, getSSRColumns, getSSRItems } from "../SSRChipSelection/components/SSRSelectionTable/utils";
import { PassengerType } from "src/Modules/Flights/constants/JourneyDetails";
import { getNumberLocale } from "src/utility";

export default function SSRItemTotal() {
  const { t } = useTranslation();
  const { cursor, SSROptions } = useSSRContext();
  const { passengersState } = useJourneyDynamicDetails();
  const [passengersInput] = passengersState;
  const passengers: PassengerType[] = passengersInput?.passengers ?? [];

  const type = cursor.ssrType;
  const ssrOption = SSROptions.find((option) => option?.value === type);
  if (!type || !ssrOption) return null;

  const columns = getSSRColumns(passengers[0], ssrOption.ssrSelectionType);
  const selectedItems = passengers.flatMap((passenger) => columns.flatMap((column) => getSSRItems(passenger, column, type)));
  const currency = selectedItems[0]?.currency ?? "";
  const formatPrice = (value: number) =>
    `${currency} ${value.toLocaleString(getNumberLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();

  const grandTotal = passengers.reduce((acc, passenger) => acc + getRowTotal(passenger, columns, type), 0);

  return (
    <div className="flex w-full items-center justify-between gap-4 px-4 py-2 md:py-3">
      <span className="text-font-subtle text-xs font-semibold uppercase tracking-wide">
        {t("Flights.details.ssr.typeTotal", { type: ssrOption.label, defaultValue: "{{type}} total" })}
      </span>
      <span className="text-font-active text-sm font-bold">{formatPrice(grandTotal)}</span>
    </div>
  );
}
